const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 393 128",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d62021",
    d: "M -0.5,-0.5 C 43.1667,-0.5 86.8333,-0.5 130.5,-0.5C 130.5,42.1667 130.5,84.8333 130.5,127.5C 86.8333,127.5 43.1667,127.5 -0.5,127.5C -0.5,84.8333 -0.5,42.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020106",
    d: "M 130.5,-0.5 C 174.5,-0.5 218.5,-0.5 262.5,-0.5C 262.5,42.1667 262.5,84.8333 262.5,127.5C 218.5,127.5 174.5,127.5 130.5,127.5C 130.5,84.8333 130.5,42.1667 130.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#237bbc",
    d: "M 262.5,-0.5 C 305.833,-0.5 349.167,-0.5 392.5,-0.5C 392.5,42.1667 392.5,84.8333 392.5,127.5C 349.167,127.5 305.833,127.5 262.5,127.5C 262.5,84.8333 262.5,42.1667 262.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 94.5,97.5 C 89.5,97.5 84.5,97.5 79.5,97.5C 79.8291,83.3234 79.4958,69.3234 78.5,55.5C 78.4087,49.8015 75.7421,45.9682 70.5,44C 62.9427,42.0747 56.6093,43.9081 51.5,49.5C 50.5036,65.3246 50.1703,81.3246 50.5,97.5C 45.5,97.5 40.5,97.5 35.5,97.5C 35.5,75.1667 35.5,52.8333 35.5,30.5C 39.5546,30.1758 43.5546,30.5091 47.5,31.5C 48.0521,33.3334 48.8855,35.0001 50,36.5C 60.8811,28.1911 72.3811,27.3578 84.5,34C 89.2525,37.4136 92.4191,41.9136 94,47.5C 94.4999,64.1633 94.6666,80.83 94.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 183.5,97.5 C 183.44,96.9569 183.107,96.6236 182.5,96.5C 181.504,102.798 181.17,109.132 181.5,115.5C 176.5,115.5 171.5,115.5 166.5,115.5C 166.5,87.1667 166.5,58.8333 166.5,30.5C 171.833,30.5 177.167,30.5 182.5,30.5C 182.343,31.8734 182.51,33.2068 183,34.5C 187.309,30.8415 192.309,29.1748 198,29.5C 219.434,30.9383 229.601,42.4383 228.5,64C 228.01,90.1492 214.677,101.816 188.5,99C 186.753,98.6481 185.086,98.1481 183.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 323.5,55.5 C 322.504,69.3234 322.171,83.3234 322.5,97.5C 317.5,97.5 312.5,97.5 307.5,97.5C 307.5,75.5 307.5,53.5 307.5,31.5C 312.5,31.5 317.5,31.5 322.5,31.5C 322.338,33.5273 322.505,35.5273 323,37.5C 323.717,36.9558 324.217,36.2891 324.5,35.5C 333.213,28.8592 342.546,27.8592 352.5,32.5C 350.421,36.9926 348.088,41.326 345.5,45.5C 334.446,40.6943 327.112,44.0276 323.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#85afd6",
    d: "M 324.5,35.5 C 324.217,36.2891 323.717,36.9558 323,37.5C 322.505,35.5273 322.338,33.5273 322.5,31.5C 317.5,31.5 312.5,31.5 307.5,31.5C 307.5,53.5 307.5,75.5 307.5,97.5C 312.5,97.5 317.5,97.5 322.5,97.5C 322.171,83.3234 322.504,69.3234 323.5,55.5C 323.5,69.8333 323.5,84.1667 323.5,98.5C 317.833,98.5 312.167,98.5 306.5,98.5C 306.5,75.8333 306.5,53.1667 306.5,30.5C 312.167,30.5 317.833,30.5 323.5,30.5C 323.216,32.4147 323.549,34.0813 324.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#040408",
    d: "M 187.5,43.5 C 203.793,40.9487 212.126,47.7821 212.5,64C 213.364,78.2983 206.697,85.7983 192.5,86.5C 189.101,86.2165 185.935,85.2165 183,83.5C 182.333,71.1667 182.333,58.8333 183,46.5C 184.652,45.6006 186.152,44.6006 187.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3c9c9",
    d: "M 51.5,49.5 C 51.5,65.8333 51.5,82.1667 51.5,98.5C 45.9738,98.8214 40.6405,98.4881 35.5,97.5C 40.5,97.5 45.5,97.5 50.5,97.5C 50.1703,81.3246 50.5036,65.3246 51.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0baba",
    d: "M 78.5,55.5 C 79.4958,69.3234 79.8291,83.3234 79.5,97.5C 84.5,97.5 89.5,97.5 94.5,97.5C 89.3595,98.4881 84.0262,98.8214 78.5,98.5C 78.5,84.1667 78.5,69.8333 78.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99999a",
    d: "M 183.5,97.5 C 182.51,103.645 182.177,109.978 182.5,116.5C 176.974,116.821 171.64,116.488 166.5,115.5C 171.5,115.5 176.5,115.5 181.5,115.5C 181.17,109.132 181.504,102.798 182.5,96.5C 183.107,96.6236 183.44,96.9569 183.5,97.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpr);
export default __webpack_public_path__ + "static/media/npr.5a2daba83459d4f77b4a8579122c8394.svg";
export { ForwardRef as ReactComponent };